import { API_BASIC_URL_DELIVERY_PROMISE, API_BASIC_URL_SLOT_SERVICE } from "../config/constants";
import { handleError, handleResponse } from "./ApiUtils";
import Fetch from "./Fetch";

export const getPOSZoneMappingList = (body) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/delivery-promise/pos-zone-mapping`, body).then(handleResponse).catch(handleError);
};

export const saveRuleEngineConfigurations = (body) => {
  return Fetch.create(`${API_BASIC_URL_DELIVERY_PROMISE}/api/v1/delivery-promise-config`, body).then(handleResponse).catch(handleError);
};

export const getRuleEngineConfigurations = (query) => {
  return Fetch.get(`${API_BASIC_URL_DELIVERY_PROMISE}/api/v1/delivery-promise-config/${query.countryId}/${query.serviceType}/${query.posId}/${query.zoneId}`).then(handleResponse).catch(handleError);
};

export const fetchCurrentConfigurationService = ({ countryId, serviceTypeName }, queryParams) => {
  return Fetch.get(`${API_BASIC_URL_DELIVERY_PROMISE}/api/v1/delivery-promise-config/${countryId}/${serviceTypeName}`, queryParams).then(handleResponse).catch(handleError);
};

export const fetchCurrentConfigurationServiceBasedOnSearch = ({ countryId, serviceTypeName }, queryParams) => {
  return Fetch.get(`${API_BASIC_URL_DELIVERY_PROMISE}/api/v1/delivery-promise-config`, queryParams).then(handleResponse).catch(handleError);
};

export const getRuleEngineConfigurationsVersionTwo = (query) => {
  return Fetch.get(`${API_BASIC_URL_DELIVERY_PROMISE}/api/v2/promise/config/${query.countryId}/${query.serviceType}/${query.posId}/${query.zoneId}`).then(handleResponse).catch(handleError);
};

export const fetchCurrentConfigurationServiceBasedOnSearchVersionTwo = ({ countryId, serviceTypeName }, queryParams) => {
  return Fetch.get(`${API_BASIC_URL_DELIVERY_PROMISE}/api/v2/promise/config/${countryId}/${serviceTypeName}`, queryParams).then(handleResponse).catch(handleError);
};

export const saveRuleEngineConfigurationsVersionTwo = (body) => {
  return Fetch.create(`${API_BASIC_URL_DELIVERY_PROMISE}/api/v2/promise/config`, body).then(handleResponse).catch(handleError);
};
